import { render, staticRenderFns } from "./DxExtremeWeatherCondicionsDatabase.vue?vue&type=template&id=7adf5523&"
import script from "./DxExtremeWeatherCondicionsDatabase.vue?vue&type=script&lang=js&"
export * from "./DxExtremeWeatherCondicionsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports